var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "py-3 px-5" },
    [
      _c(
        "b-row",
        { staticClass: "flex-column", attrs: { "no-gutters": "" } },
        [
          _c("b-skeleton", {
            attrs: { animation: "fade", width: "15%", height: "2.1rem" },
          }),
          _vm._v(" "),
          _c("b-skeleton", {
            staticClass: "mt-1",
            attrs: { animation: "fade", width: "30%", height: "1.4rem" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4", attrs: { "no-gutters": "" } },
        [
          _c("b-skeleton", {
            attrs: {
              type: "input",
              animation: "fade",
              width: "100%",
              height: "2.3rem",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-5", attrs: { "no-gutters": "" } },
        [
          _c("b-skeleton", {
            attrs: {
              type: "input",
              animation: "fade",
              width: "100%",
              height: "2.5rem",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            {
              staticClass:
                "mb-2 col-xl-2 col-lg-4 col-sm-6 col-12 add-template-col pb-3",
            },
            [
              _c("b-skeleton-img", {
                attrs: { width: "100%", height: "21rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass:
                "mb-2 col-xl-2 col-lg-4 col-sm-6 col-12 add-template-col pb-3",
            },
            [
              _c("b-skeleton-img", {
                attrs: { width: "100%", height: "21rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass:
                "mb-2 col-xl-2 col-lg-4 col-sm-6 col-12 add-template-col pb-3",
            },
            [
              _c("b-skeleton-img", {
                attrs: { width: "100%", height: "21rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass:
                "mb-2 col-xl-2 col-lg-4 col-sm-6 col-12 add-template-col pb-3",
            },
            [
              _c("b-skeleton-img", {
                attrs: { width: "100%", height: "21rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass:
                "mb-2 col-xl-2 col-lg-4 col-sm-6 col-12 add-template-col pb-3",
            },
            [
              _c("b-skeleton-img", {
                attrs: { width: "100%", height: "21rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass:
                "mb-2 col-xl-2 col-lg-4 col-sm-6 col-12 add-template-col pb-3",
            },
            [
              _c("b-skeleton-img", {
                attrs: { width: "100%", height: "21rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass:
                "mb-2 col-xl-2 col-lg-4 col-sm-6 col-12 add-template-col pb-3",
            },
            [
              _c("b-skeleton-img", {
                attrs: { width: "100%", height: "21rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass:
                "mb-2 col-xl-2 col-lg-4 col-sm-6 col-12 add-template-col pb-3",
            },
            [
              _c("b-skeleton-img", {
                attrs: { width: "100%", height: "21rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass:
                "mb-2 col-xl-2 col-lg-4 col-sm-6 col-12 add-template-col pb-3",
            },
            [
              _c("b-skeleton-img", {
                attrs: { width: "100%", height: "21rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass:
                "mb-2 col-xl-2 col-lg-4 col-sm-6 col-12 add-template-col pb-3",
            },
            [
              _c("b-skeleton-img", {
                attrs: { width: "100%", height: "21rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass:
                "mb-2 col-xl-2 col-lg-4 col-sm-6 col-12 add-template-col pb-3",
            },
            [
              _c("b-skeleton-img", {
                attrs: { width: "100%", height: "21rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass:
                "mb-2 col-xl-2 col-lg-4 col-sm-6 col-12 add-template-col pb-3",
            },
            [
              _c("b-skeleton-img", {
                attrs: { width: "100%", height: "21rem" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }